import { render, staticRenderFns } from "./FormProfileBasicInfo.vue?vue&type=template&id=4e004389&scoped=true&"
import script from "./FormProfileBasicInfo.vue?vue&type=script&lang=js&"
export * from "./FormProfileBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormProfileBasicInfo.vue?vue&type=style&index=0&id=4e004389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e004389",
  null
  
)

export default component.exports